




















































































































import { Vue, Component } from "vue-property-decorator";
import { FocusTrapModule } from "@/assets/scripts/FocusTrapModule";

@Component
export default class FocusTrapPage extends Vue {
	data() {
		return {
			PageTitle: "Focus Trap page"
		};
	}
	mounted() {
		new FocusTrapModule(this.$refs.focusEl);
	}
}
